import { createActions } from 'redux-actions';

export const {
  getCustomerCompanies,
  getCustomerCompaniesSuccess,
  getCustomerCompaniesError,
  getCustomerCompaniesSearch,
  getCustomerCompaniesSearchRequest,
  getCustomerCompaniesSearchClear,
  getCustomerCompaniesSearchSuccess,
  getCustomerCompaniesSearchError,
  clearCustomers
} = createActions(
  'GET_CUSTOMER_COMPANIES',
  'GET_CUSTOMER_COMPANIES_SUCCESS',
  'GET_CUSTOMER_COMPANIES_ERROR',
  'GET_CUSTOMER_COMPANIES_SEARCH',
  'GET_CUSTOMER_COMPANIES_SEARCH_REQUEST',
  'GET_CUSTOMER_COMPANIES_SEARCH_CLEAR',
  'GET_CUSTOMER_COMPANIES_SEARCH_SUCCESS',
  'GET_CUSTOMER_COMPANIES_SEARCH_ERROR',
  "CLEAR_CUSTOMERS"
);
